import Template from "./template";
export default Template;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/template/index.ts
// module id = Pjik
// module chunks = 2